import { combineReducers } from "redux";
import { moneyReducer } from "./moneyReducer";
import { newsReducer } from "./newsReducer";
import { orderReducer } from "./orderReducer";
import { userReducer } from "./userReducer";
import { giftReducer } from "./giftReducer";
import { ticketReducer } from "./ticketReducer";


export const rootReducer  =  combineReducers({
    userState: userReducer,
    orderState: orderReducer,
    moneyState: moneyReducer,
    giftState: giftReducer,
    ticketState: ticketReducer,
    newsState: newsReducer
})